<template>
    <div class="flex flex-col sm:flex-row md:rounded-lg md:shadow-lg md:overflow-hidden">
        <div class="sm:w-1/4 mb-4 sm:mb-0 min-w-min">
            <div :class="[$store.state.configs.sidebar_background,$store.state.configs.sidebar_text]" class="h-full flex justify-between flex-col px-6 py-12">
                <div>
                    <h1 class="mb-4 text-lg">
                        {{form.title}}
                    </h1>

                    <ol class="pl-0 list-none">
                        <li
                            v-for="(page, page_key) in pages"
                            class="md:mb-2"
                            :class="$store.state.configs.sidebar_text"
                            :key="page_key"
                            
                            :data-key="page_key"
                        >
                            <component
                                :is="page_key + 1 < $store.state.step ? ($store.state.configs.routing ? 'router-link' : 'a') : 'span'"
                                :to="`/step/${(page_key+1)}`"
                                class="flex flex-row items-center text-lg"
                                @click="page_key + 1 != $store.state.step && !$store.state.configs.routing ?
                                    $store.commit('updateField', {
                                        field : 'step',
                                        value : $store.state.step - 1
                                    })
                                    : false;
                                "
                            >
                                <div
                                    class="rounded-full w-6 h-6 flex items-center justify-center mr-2 flex-none"
                                    :class="{
                                        'bg-black text-white ring-white ring ring-inset' : page_key +1 <= $store.state.step,
                                        'bg-white text-black' : page_key + 1 > $store.state.step
                                        }"
                                >
                                    <svg v-if="page_key + 1 < $store.state.step" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-full h-auto"><path fill="currentColor" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z" class=""></path></svg>
                                </div>
                                <div
                                    :class="[{
                                        'font-bold':
                                            page_key == $store.state.step - 1,
                                    },
                                    $store.state.configs.sidebar_text]"
                                    v-text="page ? page : `Step ${(page_key + 1)}`"
                                ></div>
                            </component>
                        </li>
                    </ol>
                </div>

                <a
                    v-if="$store.state.configs.show_phone && $store.state.configs.phone"
                    :href="`tel:${$store.state.configs.phone}`"
                    class="block text-center px-4 py-2 hidden md:block text-xl"
                    :class="$store.state.configs.sidebar_text"
                >
                    <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="inline-block h-6 w-6 mr-2"><path fill="currentColor" d="M493.09 351.3L384.7 304.8a31.36 31.36 0 0 0-36.5 8.9l-44.1 53.9A350 350 0 0 1 144.5 208l53.9-44.1a31.35 31.35 0 0 0 8.9-36.49l-46.5-108.5A31.33 31.33 0 0 0 125 .81L24.2 24.11A31.05 31.05 0 0 0 0 54.51C0 307.8 205.3 512 457.49 512A31.23 31.23 0 0 0 488 487.7L511.19 387a31.21 31.21 0 0 0-18.1-35.7zM456.89 480C222.4 479.7 32.3 289.7 32.1 55.21l99.6-23 46 107.39-72.8 59.5C153.3 302.3 209.4 358.6 313 407.2l59.5-72.8 107.39 46z" class=""></path></svg>
                    {{$store.state.configs.phone}}
                </a>
            </div>
        </div>
        <div class="sm:w-3/4 px-6 py-12">
            <slot></slot>
        </div>
        <div 
            v-if="$store.state.configs.show_phone && $store.state.configs.phone" 
            :class="[$store.state.configs.sidebar_background,$store.state.configs.sidebar_text]" 
            class="p-6 md:hidden block">
            <a
                :href="`tel:${$store.state.configs.phone}`"
                class="block bg-secondary-blue-500 text-center px-4 py-2 text-white text-xl"
            >
                <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="inline-block h-6 w-6 mr-2"><path fill="currentColor" d="M493.09 351.3L384.7 304.8a31.36 31.36 0 0 0-36.5 8.9l-44.1 53.9A350 350 0 0 1 144.5 208l53.9-44.1a31.35 31.35 0 0 0 8.9-36.49l-46.5-108.5A31.33 31.33 0 0 0 125 .81L24.2 24.11A31.05 31.05 0 0 0 0 54.51C0 307.8 205.3 512 457.49 512A31.23 31.23 0 0 0 488 487.7L511.19 387a31.21 31.21 0 0 0-18.1-35.7zM456.89 480C222.4 479.7 32.3 289.7 32.1 55.21l99.6-23 46 107.39-72.8 59.5C153.3 302.3 209.4 358.6 313 407.2l59.5-72.8 107.39 46z" class=""></path></svg>
                {{$store.state.configs.phone}}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        form() {
            return window.booking_form;
        },
        pages() {
            let pages = this.form.pagination.pages;
            pages.pop();
            return pages;
        }
    },
};
</script>

<style lang="scss">
#vue-app {
    .list-none {
        list-style-type: none;
    }
}
</style>